import {
  ProductRecommendation,
  ProductRecommendationWithPrice,
} from '../../ApolloProvider/resolvers/Query/Product/ProductPage'

import { getColourSwatches } from './colorSwatch'
import { productPrice } from './price'

export const productRecommendations = (
  productRecommendation?: ProductRecommendation[],
  productContentKeys?: string[],
): { products: ProductRecommendationWithPrice[]; skus: number[] } => {
  if (!productRecommendation) {
    return { products: [], skus: [] }
  }

  return productRecommendation.reduce<{
    products: ProductRecommendationWithPrice[]
    skus: number[]
  }>(
    (accumulator, recommendation) => {
      const recommendationPrice = productPrice(recommendation)
      const colourSwatches = getColourSwatches(recommendation)
      const hoverImage =
        recommendation.images?.length > 1
          ? {
              urls: {
                largeProduct: recommendation.images[1]?.largeProduct,
              },
              alt: recommendation.title,
              fetchPriority: 'low',
            }
          : undefined

      const categories =
        recommendation?.content &&
        recommendation?.content?.filter(
          (item) => item && productContentKeys?.includes(item.key),
        )

      accumulator.products.push({
        ...recommendation,
        hoverImage,
        colourSwatches,
        categories,
        price: {
          price: recommendationPrice.price,
          rrp: recommendationPrice.rrp,
          __typename: 'ProductPrice',
        },
        inStock: recommendation.variants.some((variant) => variant.inStock),
        image: recommendation.images[0]?.largeProduct || '',
        externalIdentifier:
          recommendation.defaultVariant?.externalIdentifier || '',
        content: recommendation.defaultVariant?.content,
      })
      accumulator.skus.push(recommendation.sku)
      return accumulator
    },
    { products: [], skus: [] },
  )
}
